const site = {
  siteId: 1,
  siteIdentify: "46317460b85eb60d2ed54ea2d0ea0392",
  siteName: "人力銀行C主網"
};

const channel = {
  ...site,
  channelId: 999,
  channelIdentify: "dev-channel",
  channelName: "dev-channel"
};

const options = {
  ...channel,
  style: "",
  conditionId: 0
};

export default [
  {
    ...options,
    id: 9100,
    identify: "pc_c_companylist_sponsor_company",
    device: "PC",
    name: "pc_c_companylist_sponsor_company",
    upperLimit: 3,
    typeId: 100
  },
  {
    ...options,
    id: 8100,
    identify: "pc_c_companylist_powerbroadcast",
    device: "PC",
    name: "pc_c_companylist_powerbroadcast",
    upperLimit: 3,
    typeId: 100
  },
  {
    ...options,
    id: 9101,
    identify: "pc_c_companylist_keywords_job",
    device: "PC",
    name: "pc_c_companylist_keywords_job",
    upperLimit: 3,
    typeId: 101
  },
  {
    ...options,
    id: 8102,
    identify: "pc_c_companylist_topbanner",
    device: "PC",
    name: "pc_c_companylist_topbanner",
    upperLimit: 3,
    typeId: 102
  },
  {
    ...options,
    id: 9102,
    identify: "pc_c_companylist_skyscraper",
    device: "PC",
    name: "pc_c_companylist_skyscraper",
    upperLimit: 3,
    typeId: 102
  },
  {
    ...options,
    id: 9106,
    identify: "pc_c_industry_retailservice",
    device: "PC",
    name: "dev-type-106",
    upperLimit: 1,
    typeId: 106
  },
  {
    ...options,
    id: 9107,
    identify: "pc_c_industry_retailservice_card",
    device: "PC",
    name: "dev-type-107",
    upperLimit: 1,
    typeId: 107
  },
  {
    ...options,
    id: 9108,
    identify: "pc_c_industry_company_tag",
    device: "PC",
    name: "dev-type-108",
    upperLimit: 1,
    typeId: 108
  }
];
